<template>
<div class="searchList">
    <div class="sorts"></div>
    <div class="listGood borderTop listView borderLRB">
        <ul>
            <li v-for="(item,index) in itemList" :key="index">
                <div class="item fix">
                    <div class="imgBox fl">
                        <a :href="`https://auction.artron.net/paimai-${item.artCode}/`">
                            <el-image fit="contain" style="width: 100%;height: 100%" :src="item.coverPic">
                                <div slot="placeholder" class="image-slot">
                                    加载中<span class="dot">...</span>
                                </div>
                                <div slot="error" class="el-image__error">
                                    <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                </div>
                            </el-image>
                        </a>
                    </div>
                    <div class="infoBox fl">
                        <div>
                            <a class="auctionFont color333 fontLine" target="_blank" :href="`https://auction.artron.net/paimai-${item.artCode}/`">{{ item.show_title }}</a>
                        </div>
                        <div class="info fontSong12">
                            拍卖时间：
                            <span class="color333">{{ item.detail.attribute[3].text }}</span>
                        </div>
                        <div class="info fontSong12">
                            拍卖地点：
                            <span class="color333">{{ item.detail.attribute[4].text }}</span>
                        </div>
                        <div class="info fontSong12">
                            拍卖专场：
                            <router-link class="color333" target="_blank" :to="`/special_detail/${item.organ_code}`">{{ item.detail.attribute[2].text }}</router-link>
                        </div>
                    </div>
                    <div class="priceBox fr">
                        <template v-for="(con,k) in item.pc_extra_info">
                            <div  v-if="con.label == '估价'" class="font14 yahei color999" :key="k">
                                估价：
                                <span class="red verdanF14">{{ con.smallText ||''}} {{ con.text }}</span>
                            </div>
                        </template>
                        <template v-for="(con,k) in item.pc_extra_info">
                            <div  v-if="con.label == '成交价'" class="font14 yahei color999" :key="k">
                                成交价：
                                <span class="red verdanF14">{{con.text!='流拍'&&con.text!='撤拍'? con.smallText :''}} {{ con.text }}</span>
                            </div>
                        </template>

                    </div>
                </div>
            </li>
        </ul>
    </div>
</div>
</template>

<script>
export default {
    name: "searchList",
    props: {
        itemList: {
            type: Array
        },
        t: {
            type: Number
        }
    },
    data() {
        return {
            dataList: [{}, {}],
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/auctionCompany.scss";

.searchList {
    .listGood {
        li {
            .item {
                .imgBox {
                    border: 1px solid #f2f2f2;
                    width: 98px;
                    height: 98px;
                    text-align: center;
                    display: inline-block;
                    background: none;
                }

                .infoBox {
                    margin-top: 4px;

                    .info {
                        line-height: 20px;
                        color: #999;
                    }
                }

                .priceBox {
                    display: inline-block;
                    margin-top: 22px;
                }
            }
        }

    }
}
</style>
